module.exports = __webpack_public_path__ + "static/media/4_price.dc5befc3.svg";